import { usePathname, useRouter } from 'next/navigation';

import useMobileStore from '@/store/mobileStore';
import { usePathStore } from '@/store/pathStore';
import { appToClose } from '@/utils/js/webView';

export default function CommonBackButton({ text }: { text?: string }) {
  const router = useRouter();
  const pathName = usePathname();
  const { noPreviousPath, resetPath } = usePathStore();
  // console.log('noPreviousPath : ', noPreviousPath);
  const { isWebView } = useMobileStore();

  const handleClickBackBtn = () => {
    if (isWebView && pathName === noPreviousPath) {
      resetPath();
      appToClose();
    } else {
      router.back();
    }
  };

  return (
    <>
      <button className="btn btn_back" type="button" onClick={handleClickBackBtn}>
        {text ?? <span className="text_blind">뒤로가기</span>}
      </button>
    </>
  );
}
